// @ts-nocheck
import {
  CdkNestedTreeNode,
  CdkTree,
  CdkTreeNodeDef,
  CdkTreeNodeOutlet,
  CdkTreeNodeToggle,
  NestedTreeControl,
} from '@angular/cdk/tree';
import { Component, Input, OnChanges, SimpleChanges, forwardRef, inject } from '@angular/core';
import moment from 'moment';

//Tirar esse R daqui, decobrir o que se passa na cabeça do Joannis!!!
//@refactor
import { NgTemplateOutlet } from '@angular/common';
import { IconComponent } from '@lbca-shared/icon';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { FormTemplateService } from '../../dynamic-form/sub-modules/form-template/form-template.service';

import * as R from 'ramda';
import {
  forEachObjIndexed as forEachObjIndexedRamda,
  has as hasRamda,
  isEmpty as isEmptyRamda,
  isNil as isNilRamda,
  length as lengthRamda,
  path as pathRamda,
} from 'ramda';
import { applyDicinary } from '../../../../contants/task-status.const';
import { USER_SERVICE, UserServiceInterface } from '../../../../services/user.services';
import { InputTextComponent } from '../input-text/input-text.component';
import { SelectRoundedComponent } from '../select-rounded/select-rounded.component';
import { TextareaComponent } from '../textarea/textarea.component';
@Component({
  selector: 'lbca-tree-table',
  templateUrl: './tree-table.component.html',
  styleUrl: './tree-table.component.scss',
  imports: [
    CdkTree,
    CdkTreeNodeDef,
    CdkNestedTreeNode,
    NgTemplateOutlet,
    CdkTreeNodeToggle,
    CdkTreeNodeOutlet,
    forwardRef(() => InputTextComponent),
    forwardRef(() => SelectRoundedComponent),
    forwardRef(() => TextareaComponent),
    IconComponent,
  ],
})
export class TreeTableComponent implements OnChanges {
  private dynamicFormService = inject(DynamicFormService);
  private formTemplateService = inject(FormTemplateService);

  treeControl = new NestedTreeControl<any>((node: any) => node.children);
  private _value: any;
  private _field: any;
  private _dataSource: any;
  public canEditAssignedUser = false;
  initialized = false;
  readonly userService = inject<UserServiceInterface>(USER_SERVICE);

  public hasChild = (_: number, node: any) => !!node.children && node.children.length > 0;

  public set dataSource(value: any) {
    this._dataSource = value;
  }

  public get dataSource(): any {
    return this._dataSource;
  }

  @Input()
  public set value(value: any) {
    this._value = value;
  }

  @Input()
  public set field(value: any) {
    this._field = value;
    this.checkIfHasCapability();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.initialized && this._value && this._field) {
      this.getData();
      this.initialized = true;
    }
  }

  public get value(): any {
    return this._value;
  }

  public get field(): any {
    return this._field;
  }

  private getExternalData = async (entityUrl, params, returnFormatter) => {
    const resp: any = await this.formTemplateService.getDinamicUrl(entityUrl, params).toPromise();

    if (resp) {
      if (typeof returnFormatter === 'string') {
        return resp[returnFormatter];
      }

      if (typeof returnFormatter === 'object' && Array.isArray(returnFormatter)) {
        return pathRamda(returnFormatter, resp);
      } else if (!Array.isArray(returnFormatter)) {
        //@refactor
        const arrayReturn = (R as any)[returnFormatter['op']]((item) => {
          const response = {};
          if (lengthRamda(returnFormatter.keys) > 1) {
            returnFormatter.keys.forEach((key) => {
              response[key] = item[key];
            });
          } else {
            return item[returnFormatter.keys[0]];
          }

          return response;
        }, resp);

        return arrayReturn.length > 0 ? arrayReturn : undefined;
      }
      if (!returnFormatter && typeof resp === 'object') {
        const formatter = {
          id: resp.id,
          value: resp.id,
          label: resp.fullname,
          deleted: true,
          editLabel: true,
        };
        return formatter;
      }
    }

    return '-';
  };

  public getOptionsSelect = async (groupId) => {
    const params = { ...groupId, returnFields: true };
    const resp: any = await this.formTemplateService
      .getDinamicUrl('/user/group/getUsersByGroupId', params)
      .toPromise();
    if (resp === null) return;
    const formatter = resp.map((e) => {
      return {
        id: e.id,
        value: e.id,
        label: e.fullname,
        deleted: true,
        editLabel: true,
        ...groupId,
      };
    });
    return formatter;
  };

  private extractParametersFromEntityParameters(entityParameters: any): any {
    const params = {};
    const keys = Object.keys(entityParameters);
    keys.forEach((key) => {
      params[key] =
        this.dynamicFormService?.formControlStructure?.fieldControl?.[entityParameters[key]]?.value;
    });
    return params;
  }

  private async getData() {
    const { entityParameters, entityUrl } = this._field.auxEntity;
    const params = this.extractParametersFromEntityParameters(entityParameters);
    this.formTemplateService.getDinamicUrl<Array<any>>(entityUrl, params).subscribe(
      async (result: Array<any>) => {
        const formatterData2 = async (node: any) => {
          const response: any = {};

          const fillResponse = async (value: any, key) => {
            if (hasRamda('auxEntity', value)) {
              const { entityParameters, entityUrl, returnFormatter, options } =
                value?.auxEntity as any;
              const params: any = {};
              const keys = Object.keys(entityParameters);
              keys.forEach((key) => {
                if (node?.[entityParameters[key]]) params[key] = node?.[entityParameters[key]];
              });

              if (!isEmptyRamda(params) && !isNilRamda(params))
                response[key] = await this.getExternalData(entityUrl, params, returnFormatter);

              if (options) {
                const entityParameters = options.entityParameters;
                const params = {};
                const keys = Object.keys(entityParameters);
                keys.forEach((key) => {
                  if (node?.[entityParameters[key]]) {
                    params[key] = node?.[entityParameters[key]];
                  }
                });
                response.options = await this.getOptionsSelect(params);
              }
            } else {
              response[key] = node?.[value?.from];

              if (hasRamda('dicionary', value))
                response[key] = applyDicinary(value.dicionary as any, response[key]);
              if (hasRamda('momentFormat', value))
                response[key] = response[key]
                  ? moment.unix(response[key]).format(value.momentFormat as any)
                  : '-';
            }
          };

          forEachObjIndexedRamda(fillResponse, this._field.auxEntity.formatterResponse);
          return response;
        };

        const formetterToDataSource = (list: Array<any>) =>
          list.map(async (item: any) => {
            if (hasRamda('childrenTasks', item))
              return {
                data: await formatterData2(item),
                children: await Promise.all(formetterToDataSource(item?.childrenTasks as any)),
              };

            return { data: await formatterData2(item) };
          });

        const dataSource = await Promise.all(formetterToDataSource(result));
        this._dataSource = dataSource;
      },
      (err) => console.error('ERROR', err)
    );
  }

  public changeValue(value: string, taskId: string, isTaskFinished: boolean) {
    if (isTaskFinished) return;
    this.changeUserAssignedToTask(value, taskId);
  }

  private changeUserAssignedToTask(fromUser: string, taskId: string) {
    const toUser = localStorage.getItem('user-id');
    const payload = { fromUser, toUser, taskId };
    this.formTemplateService
      .putDinamicUrl('/task/changeUserAssigned', payload, { taskId })
      .subscribe((resp) => {});
  }

  public formatterValue(value) {
    if (typeof value === 'object') {
      return value.label;
    }
    return value;
  }
  public checkIfHasCapability() {
    this.canEditAssignedUser = this.userService.hasCapability('task/assigned_user/edit');
    return;
  }

  public toogleCollapse = ($event, data) => {
    $event.stopPropagation();

    data.opened = !data.opened;
  };
}
